var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.456535 0.375022C0.595424 0.263911 0.748201 0.204883 0.914868 0.197939C1.08154 0.190995 1.22737 0.250022 1.35237 0.375022L5.01904 4.04169L8.70654 0.354189C8.81765 0.243078 8.96695 0.190995 9.15445 0.197939C9.34195 0.204884 9.49126 0.263912 9.60237 0.375023C9.74126 0.513912 9.80723 0.663217 9.80029 0.822939C9.79334 0.982662 9.72737 1.12502 9.60237 1.25002L5.45654 5.39586C5.38709 5.4653 5.31765 5.51391 5.2482 5.54169C5.17876 5.56947 5.10237 5.58336 5.01904 5.58336C4.9357 5.58336 4.85931 5.56947 4.78987 5.54169C4.72042 5.51391 4.65098 5.4653 4.58154 5.39586L0.456535 1.27086C0.331535 1.14586 0.272508 1.00002 0.279451 0.833356C0.286396 0.666689 0.345424 0.513911 0.456535 0.375022Z",
    fill: "#2D2756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowBlack);
export default __webpack_public_path__ + "static/media/dropdown-arrow-black.beaf1d145f9d610aa93e2ca1edef0bcd.svg";
export { ForwardRef as ReactComponent };